import { Chip } from "@material-ui/core";
import styled from "styled-components";

const ChipStyled = styled(Chip)`
  margin: ${(props) => props.margin};
`;

export default ChipStyled;
